/**
 * 
 * @author Tim
 * @date 2024-01-04
 */

const urlBuild = "https://api.qikework.cn/";
const urlDev = "http://192.168.31.210:8888/";

// 果酱序列号查询助手
const appID = 'Kb3tXuGca3'
const appName = '苹果查询'

// 微信公众号配置
const wechatAppId = 'wxa15f3d31dd0195e9' // 微信公众号AppID

// 根据不同平台设置API地址
let url = process.env.NODE_ENV === 'production' ? urlBuild : urlDev;


url = process.env.NODE_ENV === 'production' ?  "/api/" :  "/";







export { url, appID, appName, wechatAppId };